import { Typography } from '@material-ui/core';
import type { CockpitRailSegment } from '../model/cockpitViewModel';
import { useCockpitStyles } from './cockpitStyles';
import {
  EvidenceRailAxis,
  EvidenceRailLegend,
  EvidenceRailSummaryView,
} from './EvidenceRailDetails';
import { EvidenceRailSegment } from './EvidenceRailSegment';
import {
  createEvidenceRailTicks,
  evidenceRailFlex,
  observedRailStates,
  summarizeEvidenceRail,
} from './evidenceRailPresentation';

export interface ActivityEvidenceRailProps {
  segments: CockpitRailSegment[];
  selectedId: string | null;
  onSelect: (nodeId: string) => void;
}

const ObservedCoverage = ({
  segments,
  selectedId,
  onSelect,
}: ActivityEvidenceRailProps) => {
  const summary = summarizeEvidenceRail(segments);
  return (
    <>
      <EvidenceRailSummaryView summary={summary} />
      <RailTrack
        segments={segments}
        selectedId={selectedId}
        onSelect={onSelect}
      />
      <EvidenceRailAxis ticks={createEvidenceRailTicks(segments)} />
      <EvidenceRailLegend states={observedRailStates(segments)} />
    </>
  );
};

function RailTrack({
  segments,
  selectedId,
  onSelect,
}: ActivityEvidenceRailProps) {
  const classes = useCockpitStyles();
  return (
    <div
      className={classes.rail}
      role="list"
      aria-label="Cobertura temporal da atividade"
    >
      {segments.map(segment => (
        <div
          key={segment.id}
          role="listitem"
          className={classes.segmentItem}
          style={{ flex: evidenceRailFlex(segment) }}
        >
          <EvidenceRailSegment
            segment={segment}
            selected={Boolean(segment.nodeId && selectedId === segment.nodeId)}
            onSelect={onSelect}
          />
        </div>
      ))}
    </div>
  );
}

export const ActivityEvidenceRail = ({
  segments,
  selectedId,
  onSelect,
}: ActivityEvidenceRailProps) => (
  <section aria-label="Cobertura temporal das evidências">
    {segments.length === 0 ? (
      <Typography>Nenhum intervalo temporal foi observado.</Typography>
    ) : (
      <ObservedCoverage
        segments={segments}
        selectedId={selectedId}
        onSelect={onSelect}
      />
    )}
  </section>
);
